import { VStack } from '@components/base/layout';
import { RepeatableTextInput } from './RepeatableTextInput';
import { KeyValueEditor } from './KeyValueEditor';
import type { KeyValuePair } from './types';

interface CollectUserInputConfigPanelProps {
  readonly getValue: (field: string) => unknown;
  readonly setValue: (field: string, value: unknown) => void;
}

export function CollectUserInputConfigPanel({
  getValue,
  setValue,
}: Readonly<CollectUserInputConfigPanelProps>) {
  return (
    <VStack gap={4}>
      <RepeatableTextInput
        label="Fields"
        placeholder="e.g. first_name"
        helperText="Field names to collect from the user."
        value={(getValue('config_fields') as string[]) ?? []}
        onChange={(value) => setValue('config_fields', value)}
      />

      <KeyValueEditor
        keyLabel="Field Name"
        valueLabel="Validation Rules"
        keyPlaceholder="e.g. first_name"
        valuePlaceholder="e.g. required|string|max:255"
        helperText="Laravel validation rules for each field."
        value={(getValue('config_validation') as KeyValuePair[]) ?? []}
        onChange={(value) => setValue('config_validation', value)}
      />
    </VStack>
  );
}
